export default "__VITE_ASSET__B3XIV$b3__"